import "../styles/research.css";
import { IconPrinter } from "@tabler/icons-react";
import { IconCube } from "@tabler/icons-react";
import { IconNetwork } from "@tabler/icons-react";
import { IconBrain } from "@tabler/icons-react";
import { IconRobot } from "@tabler/icons-react";
import { IconCloud } from "@tabler/icons-react";
import React from "react";

const researchAreas = [
  {
    title: "3D Printing",
    description: "Advancing AI-driven manufacturing and prototyping.",
    icon: IconPrinter,
  },
  {
    title: "Blockchain",
    description: "Exploring decentralized systems for secure AI transactions.",
    icon: IconCube,
  },
  {
    title: "Internet of Things",
    description: "Integrating AI with connected devices for automation.",
    icon: IconNetwork,
  },
  {
    title: "Machine Learning",
    description: "Developing intelligent models for adaptive learning.",
    icon: IconBrain,
  },
  {
    title: "Robotics",
    description: "Enhancing AI-powered robotic systems for education.",
    icon: IconRobot,
  },
  {
    title: "Cloud Computing",
    description: "Optimising AI infrastructure for scalable solutions.",
    icon: IconCloud,
  },
];

// Create a wrapper component for the icons
const IconWrapper = ({ IconComponent, size }) => {
  return <IconComponent size={size} />;
};

const Research = () => {
  return (
    <div className="research">
      <h1>Research Projects</h1>
      <p>Our grand entrance to the AI age.</p>
      <p>
        The company is taking one step closer to AI implementation by
        centralising all its research resources into the Giant Teacher Project.
        The following research areas will shape its future:
      </p>

      <section className="research-grid">
        {researchAreas.map((area, index) => (
          <div key={index} className="research-card">
            {/* Use the wrapper component here */}
            <IconWrapper IconComponent={area.icon} size={40} />
            <h3>{area.title}</h3>
            <p>{area.description}</p>
          </div>
        ))}
      </section>
    </div>
  );
};

export default Research;